
import { Disqus } from 'vue-disqus';
import { map, head, range } from 'lodash-es';
export default {
  components: {
    Disqus,
  },
  async asyncData(context) {
    try {
      const id = context.route.params.id;
      const item = await context.$content('products', id).fetch();
      return { id, ...item };
    } catch {
      context.error({ statusCode: 404 });
    }
  },
  data() {
    return {
      id: this.$route.params.id,
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: 4.93,
        ratingCount: 1,
      },
      offers: {},
      additionalProperty: [],
    };
  },
  head() {
    return {
      title: this.name,
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          content: this.name,
        },
        {
          hid: 'description',
          name: 'description',
          content: this.description,
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: this.description,
        },
      ],
      script: [
        {
          json: this.linkData(),
          type: 'application/ld+json',
        },
      ],
    };
  },
  computed: {
    nutritionData() {
      return (
        this.nutrition ||
        (this.additionalProperty || []).find(
          (property) => property.name === 'nutrition',
        )
      );
    },
    offerData() {
      if (
        this.offers &&
        this.offers.offers &&
        Array.isArray(this.offers.offers)
      ) {
        const offers = {
          priceCurrency: head(map(this.offers.offers, 'priceCurrency')),
          ...this.offers,
          highPrice: Math.max(...map(this.offers.offers, 'price')),
          lowPrice: Math.min(...map(this.offers.offers, 'price')),
          offerCount: this.offers.offers.length,
        };
        return offers;
      } else {
        return null;
      }
    },
  },
  methods: {
    range,
    async linkData() {
      const type = ['Product'];
      if (this.nutritionData) {
        type.push('MenuItem');
      }
      return {
        ...(await this.$content('products', this.id).fetch()),
        offers: { ...this.offerData, '@type': 'AggregateOffer' },
        nutrition: this.nutritionData || undefined,
        additionalProperty: undefined,
        '@type': type,
        '@context': 'http://schema.org',
      };
    },
  },
};
